module.exports = __webpack_public_path__ + "img/record_detail.0791f3e8.png";